import React from "react";
import PropTypes from "prop-types";

export default function ConversationSidebar({
  history,
  activeId,
  onOpen,
  onNewConversation
}) {
  return (
    <aside className="copilot-panel" style={{ padding: 20 }}>
      <button
        className="copilot-btn-primary"
        onClick={onNewConversation}
        style={{ width: "100%", marginBottom: 20 }}
      >
        + New Conversation
      </button>

      <h3>Conversations</h3>

      <div
        style={{
          display: "grid",
          gap: 8,
          marginTop: 14
        }}
      >
        {history.map((conversation) => (
          <button
            key={conversation.id}
            onClick={() => onOpen(conversation.id)}
            style={{
              textAlign: "left",
              padding: 12,
              borderRadius: 12,
              border:
                conversation.id === activeId
                  ? "2px solid #2B7A5F"
                  : "1px solid #D8E4E0",
              background: "#FFF"
            }}
          >
            <strong>{conversation.title}</strong>

            <div
              style={{
                fontSize: 12,
                color: "#667",
                marginTop: 4
              }}
            >
              {conversation.lastMessageAt}
            </div>
          </button>
        ))}
      </div>
    </aside>
  );
}

ConversationSidebar.propTypes = {
  history: PropTypes.array.isRequired,
  activeId: PropTypes.string,
  onOpen: PropTypes.func.isRequired,
  onNewConversation: PropTypes.func.isRequired
};

ConversationSidebar.defaultProps = {
  activeId: null
};